import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const container = document.getElementById("tangent-main-container")


i18n.use(Backend)
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        lng: container?.dataset.locale || "en",
        backend: {
            loadPath: "https://a.tangent.ai/quiz-inline/2.0.31/locale/{{lng}}/translation.json"
        },
        fallbackLng: "en",
        detection: {
            order: ['cookie', 'htmlTag', 'path'],
            caches: ['cookie']
        },
        initImmediate: false
    })

export default i18n;